import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styles from './PurchaserInformation.module.scss';
import dayjs from 'dayjs';
import IndividualClientForm from '../../../ClientInfo/Form/Individual/IndividualClientForm';
import EditModeIndividual from './EditModeIndividual/EditModeIndividual';
import EditModeCorporation from './EditModeCorporation/EditModeCorporation';

const PurchaserInformation = ({
	individuals,
	corporate,
	editMode,
	purchaserInformation,
	setPurchaserInformation,
	error,
	setError,
}) => {
	const [clients, setClients] = useState([]);

	useEffect(() => {
		console.log('individuals', individuals);
		if (individuals) {
			let individualObj = individuals;

			let individualArr = [];

			let individualObjKeys = Object.keys(individualObj);

			individualObjKeys.forEach((key, index) => {
				console.log('This is the index', index);
				var client = individualObj[key];
				client['index'] = index + 1;
				individualArr.push(client);
			});

			setClients(individualArr);
		}
	}, [individuals]);

	useEffect(() => {
		console.log('TYhi sis the clients', clients);
	}, [clients]);

	return (
		<div container className={styles.purchaser_info_wrapper}>
			<Grid container className={styles.client_details} spacing={3}>
				<Grid item xs={2} className={styles.title}>
					<div className={styles.wrap}>Purchaser Information</div>
				</Grid>
				<Grid item xs={10} className={styles.content}>
					{!editMode && (
						<>
							{individuals &&
								clients?.map((client) => (
									<div className={styles.item}>
										<Grid
											container
											className={styles.item_title}
											direction='row'
										>
											<Grid
												item
												xs={1}
												className={
													styles.numbering_wrapper
												}
											>
												<div
													className={
														styles.circled_number
													}
												>
													{client.index}
												</div>
											</Grid>
											<Grid item xs={11}>
												<div
													className={
														styles.text_content
													}
												>
													<div
														className={
															styles.client_name
														}
													>
														{`${client.firstName} ${client.lastName}`}
													</div>
													<div
														className={
															styles.detail_info
														}
													>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																Email
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{client.email}
															</Grid>
														</Grid>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																Phone Number
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{
																	client.phoneNumber
																}
															</Grid>
														</Grid>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																Date of birth
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{dayjs(
																	client
																		?.identification
																		?.report
																		?.document
																		?.dateOfBirth
																).format(
																	'DD MMMM YYYY'
																)}
															</Grid>
														</Grid>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																Address
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{`${
																	client?.address1
																} ${
																	client?.address2
																		? ', ' +
																		  client?.address2
																		: ''
																}, ${
																	client.city
																}, ${
																	client.province
																}, ${
																	client.postalCode
																}`}
															</Grid>
														</Grid>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																Occupation
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{
																	client?.occupation
																}
															</Grid>
														</Grid>
														{/* <Grid
											container
											direction='row'
											className={styles.detail_info_item}
										>
											<Grid item className={styles.label}>
												Employer Name
											</Grid>
											<Grid item className={styles.field}>
												Evaco
											</Grid>
										</Grid> */}
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																ID Type
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{
																	client
																		?.identification
																		?.report
																		?.document
																		?.type
																}
															</Grid>
														</Grid>
														<Grid
															container
															direction='row'
															className={
																styles.detail_info_item
															}
														>
															<Grid
																item
																className={
																	styles.label
																}
															>
																ID number
															</Grid>
															<Grid
																item
																className={
																	styles.field
																}
															>
																{
																	client
																		?.identification
																		?.report
																		?.document
																		?.idNumber
																}
															</Grid>
														</Grid>
													</div>
												</div>
											</Grid>
										</Grid>
									</div>
								))}
							{corporate && (
								<div className={styles.item}>
									<Grid
										container
										className={styles.item_title}
										direction='row'
									>
										<div className={styles.text_content}>
											<div
												className={styles.client_name}
											></div>
											<div className={styles.detail_info}>
												<Grid
													container
													direction='row'
													className={
														styles.detail_info_item
													}
												>
													<Grid
														item
														className={styles.label}
													>
														Corporation Name
													</Grid>
													<Grid
														item
														className={styles.field}
													>
														{
															corporate.corporationName
														}
													</Grid>
												</Grid>
												<Grid
													container
													direction='row'
													className={
														styles.detail_info_item
													}
												>
													<Grid
														item
														className={styles.label}
													>
														Director Name
													</Grid>
													<Grid
														item
														className={styles.field}
													>{`${corporate.directorFirstName} ${corporate.directorLastName}`}</Grid>
												</Grid>
												<Grid
													container
													direction='row'
													className={
														styles.detail_info_item
													}
												>
													<Grid
														item
														className={styles.label}
													>
														Address
													</Grid>
													<Grid
														item
														className={styles.field}
													>{`${corporate.address1}, ${corporate.province}, ${corporate.postalCode}`}</Grid>
												</Grid>
												<Grid
													container
													direction='row'
													className={
														styles.detail_info_item
													}
												>
													<Grid
														item
														className={styles.label}
													>
														Registration Number
													</Grid>
													<Grid
														item
														className={styles.field}
													>
														{
															corporate.registrationNumber
														}
													</Grid>
												</Grid>
												<Grid
													container
													direction='row'
													className={
														styles.detail_info_item
													}
												>
													<Grid
														item
														className={styles.label}
													>
														Type of Business
													</Grid>
													<Grid
														item
														className={styles.field}
													>
														{
															corporate.typeOfBusiness
														}
													</Grid>
												</Grid>
											</div>
										</div>
									</Grid>
								</div>
							)}
						</>
					)}
					{editMode && (
						<>
							{individuals && (
								<EditModeIndividual
									purchaserInformation={purchaserInformation}
									setPurchaserInformation={
										setPurchaserInformation
									}
									error={error}
									setError={setError}
								/>
							)}

							{corporate && (
								<EditModeCorporation
									purchaserInformation={purchaserInformation}
									setPurchaserInformation={
										setPurchaserInformation
									}
									error={error}
									setError={setError}
								/>
							)}
						</>
					)}
				</Grid>
			</Grid>
			{/* <Grid container className={styles.client_details}>
				<Grid item xs={2} className={styles.title}>
					Co-broker Information
				</Grid>
				<Grid item xs={10} className={styles.content}>
					<div className={styles.item}>
						<Grid
							container
							className={styles.item_title}
							direction='row'
						>
							<div className={styles.circled_number}>1</div>
							<div className={styles.text_content}>
								<div className={styles.client_name}>
									Mary Holly
								</div>
								<div className={styles.detail_info}>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Email
										</Grid>
										<Grid item className={styles.field}>
											jaylon@kavtek.com
										</Grid>
									</Grid>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Phone Number
										</Grid>
										<Grid item className={styles.field}>
											+1 097 0294 0496
										</Grid>
									</Grid>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Agency Name
										</Grid>
										<Grid item className={styles.field}>
											Harland Homes
										</Grid>
									</Grid>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Agency Address
										</Grid>
										<Grid item className={styles.field}>
											1206, Leduc Street, Suite 504,
											Toronto, Ontario, 1206
										</Grid>
									</Grid>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Commission %
										</Grid>
										<Grid item className={styles.field}>
											5%
										</Grid>
									</Grid>
									<Grid
										container
										direction='row'
										className={styles.detail_info_item}
									>
										<Grid item className={styles.label}>
											Nontes
										</Grid>
										<Grid item className={styles.field}>
											Special notes paragraph
										</Grid>
									</Grid>
								</div>
							</div>
						</Grid>
					</div>
				</Grid>
			</Grid> */}
		</div>
	);
};

const mapStateToProps = (state) => ({
	individuals: state.agreement?.agreementById?.clientInfo?.individual,
	corporate: state.agreement?.agreementById?.clientInfo?.corporation,
});

export default connect(mapStateToProps)(PurchaserInformation);
